// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "b5b241fa41c1e50857ef01135cd28bbea2eae9ca/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};